import * as React from "react";
import { ClinicOnboardView } from "./clinicOnboardView";
import { useCallback, useContext, useEffect, useState } from "react";
import { PageTitleContext } from "../../../context/pageTitleContext";
import { CLINIC_MANAGE_URL } from "../clinicSettings/clinicUrls";
import { useHistory } from "react-router-dom";
import { NewCase } from "../patients/newCase";
import { ClinicConfig } from "fe-common/graphql/clinic/clinicTypes";
import { ClinicConfigKeys } from "fe-common/graphql/clinic/clinicConfigKeys";
import { DEMO_CLINIC_ID } from "fe-common/commonTypes/masterClinicDefaults";
import { v4 as uuid } from "uuid";
import { useClinicContext } from "fe-web-components/clinic/ClinicContext";
import { getCurrentUserEmail } from "@kahunmedical/user-management";
import { LoadingProgress } from "fe-web-components/loader/loadingProgress";

//region [[ Styles ]]

//endregion [[ Styles ]]

//region [[ Props ]]

export interface NewDemoCaseProps {
  clinicId: string;
}

//endregion [[ Props ]]

//region [[ Functions ]]
//endregion [[ Functions ]]

export const DemoCase = () => {
  const pageTitle = useContext(PageTitleContext);
  const history = useHistory();
  const [errMsg, setErrMsg] = useState<string>(null);
  const [clinicId, setClinicId] = useState(null);
  const [creating, setCreating] = useState(true);

  const dao = useClinicContext();

  useEffect(() => {
    pageTitle.setPageTitle("Kahun demo case");
  }, [pageTitle]);

  useEffect(() => {
    //TODO: find existing *Demo* clinics for this user or create a new one
    (async () => {
      setCreating(true);
      setErrMsg(null);
      const userClinics = await dao.userClinics(true).catch((e) => {
        console.error(e.message);
      });
      const userDemoClinics =
        userClinics &&
        userClinics.filter(
          (c) =>
            c.config[ClinicConfigKeys.UnifiedConfigString]["clinic.demoMode"],
        );
      if (userDemoClinics?.length) {
        console.log("existing demo clinic:", userDemoClinics[0].id);
        setClinicId(userDemoClinics[0].id);
        setCreating(false);
      } else {
        //create new demo clinic
        console.log("creating new clinic");
        const user = await getCurrentUserEmail();
        await dao
          .createClinic(`demo${uuid()}`, `${user.split("@")[0]}'s clinic`, {
            [ClinicConfigKeys.UnifiedConfigString]: {
              "clinic.basedOnClinic": DEMO_CLINIC_ID,
              "clinic.demoMode": true,
            },
          } as ClinicConfig)
          .then((newClinic) => setClinicId(newClinic.id))
          .catch((e) => {
            console.error(e.message);
            setErrMsg("Sorry, we could not create a new demo clinic.");
          })
          .finally(() => setCreating(false));
      }
    })();
  }, [dao]);

  const onCaseSaved = useCallback(
    (newCaseDigitCode) => {
      history.push(
        `${CLINIC_MANAGE_URL}/${clinicId}/patients/${newCaseDigitCode}`,
      );
    },
    [clinicId, history],
  );

  const onCaseError = useCallback((message) => {
    setErrMsg(message);
  }, []);

  return (
    <ClinicOnboardView errMsg={errMsg}>
      {creating && <LoadingProgress label={"Loading demo clinic"} />}
      {!creating && (
        <NewCase
          clinicId={clinicId}
          onError={onCaseError}
          onSave={onCaseSaved}
        />
      )}
    </ClinicOnboardView>
  );
};
